<template>
    <v-card-actions>
        <slot name="left"></slot>

        <v-spacer></v-spacer>

        <slot name="right-prepend"></slot>

        <v-btn color="default" @click="$router.go(-1)" v-if="showBackButton">
            {{ $t('form.actions.back') }}
        </v-btn>

        <slot name="right-middle"></slot>

        <v-btn color="success" type="submit" :loading="loadingSave">
            <v-icon left small>mdi-check</v-icon>
            {{ saveText || $t('form.actions.save') }}
        </v-btn>

        <slot name="right-append"></slot>
    </v-card-actions>
</template>

<script>
export default {
    props: {
        loadingSave: {
            type: Boolean,
            default: () => {
                return false
            },
        },
        saveText: {
            type: String,
            default: () => {
                return null
            },
        },

        showBackButton: {
            type: Boolean,
            default: () => {
                return true
            },
        },
    },
}
</script>
